import { sortBy } from "lodash";

export default fieldsGroupedBySection =>
  sortBy(fieldsGroupedBySection, "order").reduce((fields, section) => {
    fields.push(...sortBy(section.fields, "order"));
    return fields;
  }, []);
